import React, { useState } from 'react'
import { getImages } from '../Const'
import { Link } from 'react-router-dom';

const FrontHeader = () => {
    const [isMob, setisMob] = useState(false);
    const onChangeBodyClass = (value) => {
        setisMob(value);
        value
            ? document.body.classList.add('overflow-active')
            : document.body.classList.remove('overflow-active');
    };

    return (
        <>
            <header className="header-wrap frontend-header">
                <div className='header-top'>
                    <div className="container text-end">Call Us:&nbsp;&nbsp; 330-329-3633</div>
                </div>
                <div className="container">
                    <div className="header-block d-flex align-items-center justify-content-between">
                        <div className="header-left w-auto">
                            <Link to="/web" className="main-logo">
                                <img src={getImages('main-logo.png')} alt='logo' />
                            </Link>
                        </div>
                        <div className="header-right text-end w-auto">
                            <div className={`d-inline-flex w-100 align-items-center justify-content-between main-menu menus-for-mobile ${isMob ? 'active' : ''}`}>
                                <ul>
                                    <li>
                                        <a href="#">Home</a>
                                    </li>
                                    <li>
                                        <a href="#">Inventory</a>
                                    </li>
                                    <li>
                                        <a href="#">Specials</a>
                                    </li>
                                    <li>
                                        <a href="#">Specials</a>
                                    </li>
                                </ul>
                            </div>
                            {/* <div className="login-block">
                        <div className="btn-group custom-dropdown">
                            <button type="button" className="btn btn-secondary dropdown-toggle text-green" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src={getImages('buil-icon.svg')}/> Little Rock, AR
                            </button>
                            <div className="dropdown-menu dropdown-menu-end">
                                <button className="dropdown-item" type="button">Action</button>
                                <button className="dropdown-item" type="button">Another action</button>
                                <button className="dropdown-item" type="button">Something else here</button>
                            </div>
                        </div>
                        <div className="btn-group custom-dropdown ms-3">
                            <button type="button" className="btn btn-secondary dropdown-toggle text-green" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src={getImages('user-icon.svg')}/> Welcome Chad
                            </button>
                            <div className="dropdown-menu dropdown-menu-end">
                                <button className="dropdown-item" type="button">Action</button>
                                <button className="dropdown-item" type="button">Another action</button>
                                <button className="dropdown-item" type="button">Something else here</button>
                            </div>
                        </div>
                    </div> */}
                            <div className={`overflow-bg d-none ${isMob ? 'active' : ''
                                }`}
                                onClick={() => onChangeBodyClass(!isMob)}
                            ></div>
                            <div className={`mobile-inner-header ${isMob ? 'active' : ''}`}
                                onClick={() => onChangeBodyClass(!isMob)}>
                                <div className={`mobile-inner-header-icon mobile-inner-header-icon-out ${isMob ? 'active' : ''
                                    }`}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default FrontHeader